import React, { Component } from 'react';

export default class Perspectives extends Component{
  render(){
    return(
      <div className="row section">
        <div className="col-sm-12">
          <div className="section panel">
            <h2>Perspectives 2017-2018 de l’USI-MENFP</h2>

            <p>
              Une partie des actions initi&eacute;es en 2017 se poursuivra en 2018. Les synergies et le mode de travail en r&eacute;seau des diff&eacute;rentes structures du MENFP, la d&eacute;mat&eacute;rialisation des proc&eacute;dures, le SIGERH,  le SIGEEE et l’accompagnement au d&eacute;veloppement du Data Center en sont de bons exemples.
            </p>

            <p>
              De la même façon, les r&eacute;ponses du SI dans le domaine de la p&eacute;dagogie innovante, dans le soutien et l’accompagnement de l’UTICE et la DFP pour le d&eacute;veloppement des nouvelles offres de formation (E-combite ...) prendront une part importante dans le plan de charges de l’USI.
            </p>

            <p>
              Un projet de d&eacute;veloppement d’application pour la saisie des listes de d&eacute;cision de fin d’ann&eacute;e des &eacute;l&egrave;ves pour toutes les classes et d’inscription de candidats aux diff&eacute;rents paliers de l’&eacute;valuation (4&egrave;me Ann&eacute;e, 6&egrave;me Ann&eacute;e, 9&egrave;me Ann&eacute;e et Secondaire),  de gestion et d’archivage des notes est &eacute;galement pr&eacute;vu. Mais, la dimension strat&eacute;gique et critique de cette application par son contenu est l’une des plus sensibles et impliquera la collaboration de plusieurs structures telles que : les Directions D&eacute;partementales, le Bureau National des Examens d’Etat, la Direction de l’Enseignement Secondaire, la Direction de l’Enseignement Fondamentale et le Bureau de l’Evaluation Nationale de 4&egrave;me Ann&eacute;e.
            </p>

            <p>
              Toutes ces &eacute;volutions m&eacute;tiers imposeront une prise en charge renouvel&eacute;e des transformations qu'elles sous-tendent : accompagnement du changement, formations r&eacute;currentes, place du num&eacute;rique dans notre quotidien...
            </p>

            <p>
              Au dernier trimestre de 2017, l’USI pr&eacute;voit de poursuivre les actions d’am&eacute;lioration de la qualit&eacute; des donn&eacute;es du SI en lançant un chantier de « mise &agrave; jour et mise en coh&eacute;rence des r&eacute;f&eacute;rentiels », dans un cadre plus global de la gestion des processus m&eacute;tier (BPM) et de l'architecture orient&eacute;e services (SOA). Toutefois, ce d&eacute;ploiement engendre certaines difficult&eacute;s, mais la priorit&eacute; &agrave; la qualit&eacute; des donn&eacute;es sera maintenue afin de pouvoir lui adosser les nouveaux services num&eacute;riques (notamment la d&eacute;mat&eacute;rialisation). On enchaînera ainsi &agrave; relever le d&eacute;fi de l’obsolescence de certaines pratiques d’&eacute;change d’informations entre les structures internes et externes.
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Perspectives.js